module.exports = __webpack_public_path__ + "static/media/PaymentFullScreen.469c1a80.png";